const IMAGE_ASSETS_URL = process.env.REACT_APP_IMAGE_ASSETS_URL;

export const getEventImageUrl = (imagePath) => {
  if (!imagePath) return '';

  const imageName = String(imagePath).split(/[\\/]/).pop();
  if (!IMAGE_ASSETS_URL || !imageName) return imagePath;

  return `${IMAGE_ASSETS_URL.replace(/\/+$/, '')}/${imageName}`;
};